export const LogsActionTypes = {
  API_RESPONSE_SUCCESS: '@@logs/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@logs/API_RESPONSE_ERROR',

  GET_LOG: '@@logs/GET_LOG',
  LIST_LOGS: '@@logs/LIST_LOGS',
  ADD_LOG: '@@logs/ADD_LOG',
  UPDATE_LOG: '@@logs/UPDATE_LOG',
  DELETE_LOG: '@@logs/DELETE_LOG',
  DISTINCT_USERS: '@@logs/DISTINCT_USERS',

  RESET: '@@logs/RESET'
}
